/**
 * Takes a RegExp and returns a string representation formatted in the style of the Chrome devtools
 * JS console.
 */
export function formatRegExp(value: RegExp): string {
	// Use RegExp's implementation of `toString` to prevent overriding by subclasses.
	const regExpToString = RegExp.prototype.toString;
	return regExpToString.call(value);
}
